























































































import moment from 'moment';
import Vue from 'vue';
import { cloneDeep } from 'lodash';
import { mapActions } from 'vuex';
import { AxiosError } from 'axios';

import PriceSnapshotPicker from '@/components/snapshot/PriceSnapshotPicker.vue';

import { ALForm } from '@/common/component.types';

import {
  CustomerPricingFieldError,
  ICustomerPricing,
  ICustomerPricingData
} from '@/models';
import { ErrorManager } from '@/models/error';
import ALDialog from '../core/Dialog/ALDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'CustomerPricingFormDialog',

  components: {
    PriceSnapshotPicker,
    ALDialog,
    ErrorAlert
  },

  data() {
    return {
      isEdit: false,
      isFormValid: false,

      validityMenu: false,
      customerPricingDialog: false,
      customerPricingLoading: false,
      customerPricing: null as null | ICustomerPricing,
      customerPricingOriginalCopy: null as null | ICustomerPricing,
      fieldError: new CustomerPricingFieldError(),
      customerPricingErrorMessageDetail: '',

      errorMessage: '',
      detailErrorMessage: '',

      requiredRules: [(v: string) => !!v || 'This field is required']
    };
  },

  methods: {
    ...mapActions({
      addCustomerPricing: 'customer/addCustomerPricing',
      updateCustomerPricingValidity: 'customer/updateCustomerPricingValidity'
    }),

    open(customerPricing: ICustomerPricing, isEdit = false) {
      this.customerPricingOriginalCopy = customerPricing;
      this.customerPricing = cloneDeep(customerPricing);
      this.isEdit = isEdit;
      this.clearAllErrors();
      this.customerPricingDialog = true;

      this.resetFormValidation();
    },

    allowedDates: (val: string) => {
      const today = new Date();

      // TODO: LF-2022-Temporarily allow user to select prior day for testing
      // setting expired contract. Should replace "yesterday" with "today"
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      return moment(val).isSameOrAfter(yesterday, 'day');
    },

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';

      this.customerPricingErrorMessageDetail = '';
      this.fieldError.clearErrors();
    },

    resetFormValidation(): void {
      if (this.$refs.form) {
        return this.$refs.form.resetValidation();
      }
    },

    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    submitCustomerPricing(data: ICustomerPricingData) {
      if (this.validateForm()) {
        this.customerPricingLoading = true;

        try {
          if (this.isEdit) {
            this.updateCustomerPricingValidity(data);
          } else {
            this.addCustomerPricing(data);
          }

          this.close();
        } catch (err) {
          const error = err as AxiosError;
          if (error.response) {
            // client received an error response that falls out of range 2xx
            if (
              CustomerPricingFieldError.isCustomerPricingFieldError(
                error.response.data
              )
            ) {
              this.fieldError = new CustomerPricingFieldError(
                error.response.data
              );
            }
          }

          this.customerPricingErrorMessageDetail = ErrorManager.extractApiError(
            error
          );
        } finally {
          this.customerPricingLoading = false;
        }
      }
    },

    close() {
      this.customerPricingDialog = false;
    }
  }
});
